module.exports = __webpack_public_path__ + "static/bb-video-v3-7adf99ccd9f55fa7678b33990b85b3c4.mp4";